/********************************************************************
 *
 *
 * @type {{getInstance: (function(): {setToken: function(*): void, getToken: function(): string|null})}}
 *
 * this is a singleton  file which can be used to set up the auth information just once which can be used by the auth interceptor
 *
 *********************************************************************************/
let csrfToken = null;

export const auth = (function () {
    // let token = window.localStorage.getItem('token') || process.env.REACT_APP_TOKEN;

    function init() {
        // console.log("token go go", token)

        const getCsrfTokenFromCookies = () => {
            const cookies = document.cookie.split("; ");
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].split("=");
                if (cookie[0] === "CSRF-TOKEN") {
                    return decodeURIComponent(cookie[1]);
                }
            }
            console.warn("CSRF token not found in cookies.");
            return null;
        };

        return {
            getToken: () => {
                const token = window.localStorage.getItem('token') || process.env.REACT_APP_TOKEN;
                console.log("Retrieved token:", token);
                return token
            },
            setToken: function (tokenVal) {
                console.log("inside setToken: ", tokenVal);
                window.localStorage.setItem('token', tokenVal);
                csrfToken = getCsrfTokenFromCookies();
                if (csrfToken) {
                    console.log("CSRF token retrieved:", csrfToken); // Debugging log
                }
            },
            delToken: function () {
                window.localStorage.removeItem('token')
            },
            getTokenValue: () => {
                let token = auth.getInstance()?.getToken()?.split('.')[1];
                if (token)
                    return JSON.parse(atob(token))
                else
                    return {}
            },
            getCsrfToken: () => csrfToken
        };
    }

    return {
        getInstance: () => init()
    }
})();
